/* istanbul ignore file */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import {setAllEnLabels} from "../reducers/signUpSlice";
import { store } from "../store";
import { entityToLocaleFolder } from "./entityLocaleFolder";

let node_env = process.env.NODE_ENV;

export const getBaseURL = () => {
	if (!node_env || node_env === "development") {
		return "";
	}
	return process.env.REACT_APP_CDN_URL;
};

i18n
	.use(Backend)
	.use(I18nextBrowserLanguageDetector)
	.use(initReactI18next)
	.init({
		backend: {
			loadPath: (lngs, namespaces) => {
				const lng = lngs[0];
				const ns = namespaces[0];
				const rawEntity = localStorage.getItem("SELECTED_ENTITY");
				const entity = entityToLocaleFolder(rawEntity);
				if (!entity) return null;
				return `${getBaseURL()}/locales/${entity}/${lng}/${ns}.json`;
			},
		},
		fallbackLng: false,
		supportedLngs: ["en-US", "fr-FR", "zh-CN", "zh-TW", "de-DE", "ar-AE", "el-GR", "id-ID", "ms-MY", "vi-VN", "pl-PL", "es-ES", "it-IT", "sv-SE", "nl-NL"],
		// Only eager-load namespaces needed on the early onboarding screens. i18next fetches any
		// namespace not listed here on demand the first time a component calls useTranslation([ns])
		// for it (all 5 payment-* / paymentInReview components already do this) — omitting them here
		// keeps entity/language switches from re-fetching payment translations before the user is
		// anywhere near the payment flow. reloadResources() calls elsewhere default to this same list
		// when they don't pass an explicit namespace array, so this is the single place to control it.
		ns: [
			"language",
			"crs",
		],
		defaultNS: "language",
		fallbackNS: "language",
		interpolation: {
			escapeValue: false,
		},
		react: {
			useSuspense: false,
		},
		saveMissing: node_env !== "production",
		missingKeyHandler: (lngs, ns, key) => {
			console.warn(`[i18n] Missing key: "${key}" | ns: "${ns}" | lang: "${lngs}"`);
		},
	})
	.catch(console.error);

let loadedDebounce = null;
i18n.on("loaded", () => {
	clearTimeout(loadedDebounce);
	loadedDebounce = setTimeout(() => {
		// getAllEnLabels need to have english only as we are sending it to BE
		i18n.loadLanguages("en-US", () => {
			const labels = i18n.getResourceBundle("en-US", "language");
			if (labels) {
				store.dispatch(setAllEnLabels(labels));
			}
		});
	}, 50);
});

export default i18n;
